import { Component, Input, OnInit } from '@angular/core';
import { PropertyPipe } from '../../app-lite/table/pipes/property.pipe';

import { TableColumn } from '../../app-lite/table/types/table-column';

@Component({
  template: require('./dealership.badge.component.html')
})
export class DealershipBadgeComponent implements OnInit {
  data: any;

  @Input() column: TableColumn;
  @Input() record: any;

  constructor (
    private propertyPipe: PropertyPipe
  ) {}

  ngOnInit () {
    this.data = this.propertyPipe.transform(this.column.field, this.record);
  }
}